module.exports = "/_next/static/images/asseen-856b7a44ae25b474bf3004d1b4ce6dc9.png";